import React from "react";

export function LayoutSplashScreen(props) {
  return (
    <div id="splash-screen" className="kt-splash-screen">
      <h3>{BASE_TITLE}</h3>
    </div>
  );
}
